<template>
  <div
    v-platform-expose="moduleExpose"
    class="cashback-purchase-container"
  >
    <div
      v-if="rakeBackModuleInfo.isWeekend"
      class="cashback-purchase-header-bg"
    />
    <quark-shopping-cashback
      ref="cashbackRef"
      page-id="Welfare"
      scene-name-en="platform_points"
      sub-scene-name-en="pp_order_coin_back"
      :env="mobileEnv"
      scene="rebateBonus"
      auxo-grid-module-key="welfare"
      :use-cache="false"
      :use-new-ui="true"
      :style-version="rakeBackModuleInfo.styleVersion"
      @emitevent="handleEmit"
    >
      <div
        slot="header"
        class="cashback-purchase-header"
      >
        <div class="header-left">
          <highlight-text
            :text="rakeBackModuleInfo.title"
            :normal-style="{ fontSize: '0.15rem', color: '#242729' }"
            :highlight-style="{ color: '#f7462d', fontSize: '0.15rem' }"
          />
          <div
            v-if="rakeBackModuleInfo.rebateRatio"
            class="rebate-info"
            @click="handleUseGuideClick"
          >
            <img
              class="coin-icon"
              src="https://m.hellobike.com/82cd0c93_image%201276.png"
              alt=""
            >
            <span class="rebate-info-text">{{ rakeBackModuleInfo.rebateRatio }}</span>
            <img
              class="arrow-icon"
              src="https://m.hellobike.com/d3d482211c.png"
              alt=""
            >
          </div>
        </div>
        <div class="header-right">
          <div
            class="order-btn"
            @click="handleOrderClick"
          >
            <span>我的订单</span>
            <img
              class="arrow-icon"
              src="https://m.hellobike.com/15e7879a35.png"
              alt=""
            >
          </div>
        </div>
      </div>
      <div
        slot="banner"
        class="cashback-purchase-banner"
      >
        <template v-if="rakeBackModuleInfo.isShow && !countDownEnd">
          <new-customer-reward
            v-if="rakeBackModuleInfo.bannerActivityTask"
            class="operation-area"
            :info="rakeBackModuleInfo.bannerActivityTask"
            @countDownEnd="handleCountDownEnd"
            @btnClick="handleNewBannerClick"
          />
        </template>
        <template v-else>
          <cashback-banner
            v-if="rakeBackModuleInfo.isShowBannerList"
            class="operation-area"
            :title="rakeBackModuleInfo.text"
            :list="rakeBackModuleInfo.bannerList"
            @bannerClick="handleBannerClick"
          />
        </template>
      </div>
      <div slot="clipboardTitle" />
    </quark-shopping-cashback>
  </div>
</template>

<script>
import '@hb/generate-income-components';
import { HighlightText } from '@hb/platformui-h5';
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import SPM from '../../common/spm';
import CashbackBanner from './cashback-banner';
import NewCustomerReward from '../../new-version-cpns/new-customer-reward';

export default {
  name: 'CashbackPurchase',
  components: {
    CashbackBanner,
    NewCustomerReward,
    HighlightText,
  },
  props: {
    // 电商返佣模块信息
    rakeBackModuleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 设备环境
      mobileEnv: config.env === 'dev' ? 'fat' : config.env,
      // 倒计时是否结束
      countDownEnd: false,
      // 购物反币渠道icon列表
      channelList: [
        {
          key: '淘宝',
          icon: 'https://m.hellobike.com/f00578cf_FuNftpjONLnPClmbds8dZRT70GbF_2.png',
        },
        {
          key: '京东',
          icon: 'https://m.hellobike.com/a05b7ab5e9.png',
        },
      ],
    };
  },
  methods: {
    moduleExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_onlineretailers_return30',
        contentId: 'platform_onlineretailers_return30',
        businessInfo: {},
      });
    },
    // 处理倒计时结束
    handleCountDownEnd() {
      this.countDownEnd = true;
    },
    // 处理组件事件
    handleEmit(e) {
      if (e.detail.type === 'loaded') {
        this.$emit('loaded');
        return;
      }
      if (e.detail.type === 'cashback') {
        this.$emit('bounty');
      }
      if (e.detail.type === 'order') {
        this.handleOrderClick();
      }
    },
    // 跳转订单页
    handleOrderClick() {
      const url = `https://m.hellobike.com/AppCommercialH5/${this.mobileEnv !== 'pro' ? `${this.mobileEnv}/` : ''
      }latest/index.html#/myorder?scene=rebateBonus`;
      jumpUrl(url);

      // 订单点击埋点
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_myorder',
        businessInfo: {},
      });
    },
    // 跳转使用指南
    handleUseGuideClick() {
      jumpUrl(
        'https://m.hellobike.com/mf/spa/u_xkyjzd/latest/MA2504087308769061950390860.html?activityCode=MA2504087308769061950390860',
      );
      SPM.clickButton({
        buttonName: 'platform_onlineretailers_return30',
        businessInfo: {},
      });
    },
    // banner点击跳转
    handleBannerClick(item) {
      this.handleExternalJump(item);
    },
    // 外部跳转
    handleExternalJump(item) {
      const { cashbackRef } = this.$refs || {};
      if (cashbackRef && cashbackRef.channelClick) {
        cashbackRef.channelClick(item);
      }
    },
    // 新banner点击跳转
    handleNewBannerClick() {
      const { bannerActivityTask } = this.rakeBackModuleInfo;
      this.handleExternalJump(bannerActivityTask);
    },
    // 读取剪贴板
    readClipboard() {
      const { cashbackRef } = this.$refs || {};
      if (cashbackRef && cashbackRef.readClipboard) {
        cashbackRef.readClipboard();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cashback-purchase-container {
  overflow: hidden;
  position: relative;
  padding: 0.04rem 0;
  background-color: #fff;
  border-radius: 0.16rem;
}

.cashback-purchase-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 0.4rem;
  background-image: url('https://m.hellobike.com/5c860b364c.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.cashback-purchase-header {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;

  .header-left {
    display: flex;
    align-items: center;
    font-weight: 600;

    .rebate-info {
      display: flex;
      align-items: center;
      margin-left: 0.07rem;
    }

    .coin-icon {
      margin-right: 0.02rem;
      width: 0.15rem;
      height: 0.15rem;
      vertical-align: bottom;
    }

    .rebate-info-text {
      font-size: 0.12rem;
      font-weight: 600;
      color: #fb750f;
      line-height: normal;
    }

    .arrow-icon {
      width: 0.1rem;
      height: 0.1rem;
      vertical-align: bottom;
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .order-btn {
      display: flex;
      align-items: center;
      font-size: 0.12rem;
      line-height: normal;
      color: #879099;
    }

    .arrow-icon {
      width: 0.12rem;
      height: 0.12rem;
      vertical-align: bottom;
    }
  }
}

.cashback-purchase-banner {
  margin: 0.1rem 0 0.12rem;
}
</style>
